import _toConsumableArray from "/vercel/16327899/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
import { combineParsers } from "./combine-parser";
import { background, border, color, flexbox, grid, others, position, shadow, space, typography, layout, outline } from "./configs";
import { pseudoPropNames } from "./pseudo";
export var parser = combineParsers(background, border, color, flexbox, layout, outline, grid, others, position, shadow, space, typography);
var layoutParser = combineParsers(space, layout, flexbox, grid, position);
export var layoutPropNames = layoutParser.propNames;
export var propNames = [].concat(_toConsumableArray(parser.propNames), _toConsumableArray(pseudoPropNames));